import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ContentService } from "../services/content.service";
import { DonorJourneySection } from "../models/donor-journey-section.model";
import { ContactUsModalComponent } from '../shared/contact-modal/contact-modal.component'; // adjust path
import { AuthService } from "../services/auth.service";
import { EMPTY, catchError, forkJoin, throwError } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-donor-journey",
  templateUrl: "./donor-journey.component.html",
  styleUrl: "./donor-journey.component.scss",
})
export class DonorJourneyComponent implements OnInit {
  userName = ""; // Example username
  activeTab = "Journey";
  journeySections: DonorJourneySection[] = [];
  donorLocale = "";
  areSectionsLoading = true;

  isAdmin = false;
  isComprehensiveQuestionnaireCompleted = false;
  private readonly comprehensiveQuestionnaireSectionId =
    "JS_28be6f2a-814f-47f6-9942-29a9d37565df";

  constructor(
    private contentService: ContentService,
    private authService: AuthService,
    private router: Router,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.areSectionsLoading = true;
    this.isAdmin = this.authService.isAdmin() || this.authService.isStaff();

    forkJoin({
      profileInfo: this.contentService.getDonorProfile().pipe(
        catchError((error) => {
          if (error.status === 404) {
            console.log(
              "Profile Info not found (404), navigating to preinitial."
            );
            this.router.navigate(["questionnaire/preinitial"]);
            this.areSectionsLoading = false;
            return EMPTY; // Stop further execution
          }
          return throwError(() => error);
        })
      ),
      journeySections:
        this.contentService.getDonorJourneySectionStatusForUser(),
    }).subscribe({
      next: ({
        profileInfo,
        journeySections,
      }: {
        profileInfo: any;
        journeySections: DonorJourneySection[];
      }) => {
        if (profileInfo && journeySections) {
          this.userName = `${profileInfo?.data?.donor?.firstName} ${profileInfo?.data?.donor?.lastName}`;
          this.donorLocale =
            profileInfo?.data?.donor?.locale ||
            profileInfo?.data?.donor?.preferredLocale ||
            "";
          this.journeySections = journeySections;
          const comprehensiveSection = journeySections.find(
            (section) => section.sectionId === this.comprehensiveQuestionnaireSectionId
          );
          this.isComprehensiveQuestionnaireCompleted =
            comprehensiveSection?.currentStatus === "Completed";
          this.areSectionsLoading = false;
        } else {
        }
      },
      error: (error) => {
        console.error("Error fetching data:", error);
        this.areSectionsLoading = false;
      },
    });
  }

  switchTab(tab: string): void {
    if (tab === "Knowledge") {
      window.open("https://donatelife.net/faqs/living-donation/", "_blank");
      return;
    }

    this.activeTab = tab;
  }
  
  openContactModal(): NgbModalRef {
    return this.modalService.open(ContactUsModalComponent, {
      centered: true,
      backdrop: "static",
    });
  }
  
}
